/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 查询用户限购数量
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  showId: number,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: number;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/good/show/residue/${showId}`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
